import * as types from './mutation-type'

export default {
    [types.SET_USER_INFO](state, userInfo) {
        state.userInfo = userInfo
        //localStorage.setItem('userInfo',JSON.stringify(userInfo))
    },
    [types.SET_TABS_INDEX](state, index) {
        state.tabsIndex = index
    },
    [types.SET_EQUIPMENTID](state, EquipmentId) {
        state.EquipmentId = EquipmentId
    },
    [types.SET_HOMEDESKTOP](state, HomeDesktop) {
        state.HomeDesktop = HomeDesktop
    },
    [types.SET_WAREHOUSELIST](state, WarehouseList) {
        state.WarehouseList = WarehouseList
    },
    [types.SET_IMGSHOW](state, ImgShow) {
        state.ImgShow = ImgShow
    },
    [types.SET_CLIENTINFO](state, ClientInfo) {
        state.ClientInfo = ClientInfo
    },
    [types.SET_SUP_COLLAB_SHARE_VERIFY_CODE](state, code) {
        state.supCollabShareVerifyCode = code
    }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js